<template>
  <form @submit.prevent="handleSubmit" class="space-y-5">
    <div class="space-y-1.5">
      <input
        type="email"
        v-model="email"
        placeholder="El. paštas"
        class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        autocomplete="email"
        required
      />
    </div>

    <div class="space-y-1.5">
      <input
        type="password"
        v-model="password"
        placeholder="Slaptažodis"
        class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        autocomplete="current-password"
        required
      />
    </div>

    <div class="flex items-center">
      <input
        type="checkbox"
        id="remember"
        class="w-4 h-4 border-gray-300 rounded text-blue-600 focus:ring-blue-500"
      />
      <label for="remember" class="ml-2 text-sm text-gray-600"
        >Prisiminti</label
      >
    </div>

    <div v-if="error" class="p-4 bg-red-50 text-red-600 rounded-lg text-sm">
      {{ error }}
    </div>

    <button
      type="submit"
      class="w-full py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:ring-4 focus:ring-blue-200"
      :disabled="isLoading"
    >
      {{ isLoading ? "Jungiamasi..." : "Prisijungti" }}
    </button>
  </form>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";

const router = useRouter();
const authStore = useAuthStore();

const email = ref("");
const password = ref("");
const error = ref("");
const isLoading = ref(false);

const handleSubmit = async () => {
  try {
    error.value = "";
    isLoading.value = true;
    await authStore.login({
      email: email.value,
      password: password.value,
    });
    router.push("/dashboard");
  } catch (err) {
    error.value = "Prisijungti nepavyko";
  } finally {
    isLoading.value = false;
  }
};
</script>
